import { render, staticRenderFns } from "./receiptsettings.vue?vue&type=template&id=d4f54a72&scoped=true"
import script from "./receiptsettings.vue?vue&type=script&lang=js"
export * from "./receiptsettings.vue?vue&type=script&lang=js"
import style0 from "./receiptsettings.vue?vue&type=style&index=0&id=d4f54a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f54a72",
  null
  
)

export default component.exports